import NoContentState from '../components/NoContentState';
import PlainLayout from '../layout/PlainLayout';

const reloadPage = () => window.location.reload();

const ErrorPage = () => (
    <PlainLayout>
        <NoContentState
            iconName='exclamation-sign'
            headline='Something went wrong'
            action={{ text: 'Reload page', onClick: reloadPage }}
        />
    </PlainLayout>
);

export default ErrorPage;
